import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {SettingService} from '../../../../common/services/Setting.service';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-setting-sale-agency',
  templateUrl: 'setting-sale-agency.templete.html',
  styleUrls: ['./business.css'],
  providers: [SettingService],
})
export class SettingSaleAgencyComponent implements OnInit {
  @Input('dataAgency') dataAgency: any;
  @Output('backToList') backToList = new EventEmitter();
  public data: any;

  constructor(
    private _fb: FormBuilder,
    private settingService: SettingService,
    private toastr: ToastrService,
  ) {
  }

  ngOnInit() {
    this.data = {...this.dataAgency}
  }

  goBack() {
    this.backToList.emit({
      isBack: true,
    });
  }

  submitFormAgency() {
    const type = []
    if (this.data.pp == true) {
      type.push(1)
    }
    if (this.data.sms == true) {
      type.push(3)
    }
    if (this.data.loyalty == true) {
      type.push(2)
    }
    const body = {
      'settingType': 2,
      'type': type
    }
    this.settingService.updateSettingConfig(body).subscribe((res: any) => {
      console.log('res', res)
      if (res.code == 1) {
        console.log('resssssss', res.code)
        this.toastr.success('Thành công', 'Thông báo', {
          timeOut: 4000, positionClass: 'toast-bottom-right'
        })
      }
    }, (err: any) => {
      this.toastr.success(err, 'Thông báo', {
        timeOut: 4000, positionClass: 'toast-bottom-right'
      })
    })
    setTimeout(() => {
      this.goBack()
    }, 100)
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/business/setting-sale-agency.component.ts